export enum AppRoutes {
    ROUTE_DEFAULT = "/",
    ROUTE_HOME = "/inicio",
    ROUTE_V1_MEP = "/v1/",
    ROUTE_SUMARY_PAYMENTS = "/v1/#/inicio/mis-pagos",
    ROUTE_TERMS_CONDITIONS = "/terminos-condiciones",
    // ACTUALIZACIÓN DE DATOS
    ROUTE_CLIENT_INFORMATION_UPDATE = "/v1/#/inicio/mis-datos/actualizar",
    ROUTE_CLIENT_INFORMATION = "/v1/#/inicio/mis-datos",
    // AFILIACIÓN PÓLIZA ELECTRÓNICA
    ROUTE_DIGITAL_POLICY = "/v1/#/inicio/solicitudes/registro/poliza-electronica",
    // PGA
    ROUTE_V1_PGA_PAYMENTS = "/v1/#/pga/proteccion-de-tarjeta/:productCode/mis-pagos/:systemCode/:policyId",
    ROUTE_V1_PGA_COBERAGES_EXCLUSIONS = "/v1/#/pga/proteccion-de-tarjeta/:productCode/coberturas/:systemCode/:policyId",
    // OTP
    ROUTE_REQUESTS_OTP = "/v1/#/inicio/solicitudes/registro/:requestType/otp",
    // AFTER PAYMENT ROUTES
    ROUTE_REQUESTS_OTP_PAYMENT_GATEWAY_OK = "/solicitudes/registro/pasarela-pagos/otp/response/ok",
    ROUTE_REQUESTS_OTP_PAYMENT_GATEWAY_ERROR = "/solicitudes/registro/pasarela-pagos/otp/response/error",
    V1_ROUTE_REQUESTS_OTP_PAYMENT_GATEWAY_OK = "/v1/#inicio/solicitudes/registro/pasarela-pagos/otp/response/ok",
    V1_ROUTE_REQUESTS_OTP_PAYMENT_GATEWAY_ERROR = "/v1/#/inicio/solicitudes/registro/pasarela-pagos/otp/response/error",
    ROUTE_AFTER_OTP_COMPLETE = "/solicitudes/completo",
}
